import React from "react";
import BtnLoader from "../BtnLoader/BtnLoader";

const SubmitButton = (props) => {
  const { handleSubmit, loaders } = props;
  return (
    <>
      <button
        className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
        onClick={handleSubmit}
      >
        {loaders ? (
          <BtnLoader />
        ) : (
          <>
            Submit <i className="fas fa-sign-out" />
          </>
        )}
      </button>
    </>
  );
};

export default SubmitButton;
